// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OrganizationOverviewQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type OrganizationOverviewQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    name: string;
    permittedToCreateServers: boolean;
    visibleServerGroupCount: number;
    visibleServerCount: number;
  } | null;
};

export const OrganizationOverviewDocument = gql`
  query OrganizationOverview($organizationSlug: ID!) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      name
      permittedToCreateServers
      visibleServerGroupCount
      visibleServerCount
    }
  }
`;

/**
 * __useOrganizationOverviewQuery__
 *
 * To run a query within a React component, call `useOrganizationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOverviewQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOrganizationOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationOverviewQuery,
    OrganizationOverviewQueryVariables
  > &
    (
      | { variables: OrganizationOverviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationOverviewQuery,
    OrganizationOverviewQueryVariables
  >(OrganizationOverviewDocument, options);
}
export function useOrganizationOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationOverviewQuery,
    OrganizationOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationOverviewQuery,
    OrganizationOverviewQueryVariables
  >(OrganizationOverviewDocument, options);
}
// @ts-ignore
export function useOrganizationOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationOverviewQuery,
    OrganizationOverviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrganizationOverviewQuery,
  OrganizationOverviewQueryVariables
>;
export function useOrganizationOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationOverviewQuery,
        OrganizationOverviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrganizationOverviewQuery | undefined,
  OrganizationOverviewQueryVariables
>;
export function useOrganizationOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationOverviewQuery,
        OrganizationOverviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationOverviewQuery,
    OrganizationOverviewQueryVariables
  >(OrganizationOverviewDocument, options);
}
export type OrganizationOverviewQueryHookResult = ReturnType<
  typeof useOrganizationOverviewQuery
>;
export type OrganizationOverviewLazyQueryHookResult = ReturnType<
  typeof useOrganizationOverviewLazyQuery
>;
export type OrganizationOverviewSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationOverviewSuspenseQuery
>;
export type OrganizationOverviewQueryResult = Apollo.QueryResult<
  OrganizationOverviewQuery,
  OrganizationOverviewQueryVariables
>;
